import { useEffect } from "react";
import { getPortalUrl } from "../lib/portal-url";
import "./paywall.css";

export interface PaywallModalProps {
  open: boolean;
  onClose: () => void;
  featureTitle?: string;
  portalUrl?: string;
  toolSlug?: string;
  /** Trial expiry copy for premium feature previews. */
  variant?: "license" | "trial";
  priceLabel?: string;
  toolDisplayName?: string;
}

function licenseMessage(featureTitle: string): string {
  if (featureTitle === "mobiele bediening") {
    return "Om met je mobiel te verbinden, moet je de betaalde versie hebben.";
  }
  return `Om ${featureTitle} te gebruiken heb je een betaalde licentie voor deze tool nodig via het Interact GGZ portaal.`;
}

function resolveToolSlug(explicit?: string): string | undefined {
  if (explicit) return explicit;
  if (typeof import.meta !== "undefined" && import.meta.env?.VITE_TOOL_SLUG) {
    return String(import.meta.env.VITE_TOOL_SLUG);
  }
  return undefined;
}

export function PaywallModal({
  open,
  onClose,
  featureTitle = "deze functie",
  portalUrl,
  toolSlug,
  variant = "license",
  priceLabel,
  toolDisplayName = "deze tool",
}: PaywallModalProps) {
  const portal = getPortalUrl(portalUrl);
  const slug = resolveToolSlug(toolSlug);
  const purchaseUrl = slug
    ? `${portal}/kopen/${encodeURIComponent(slug)}`
    : portal;

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="jari-paywall-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="paywall-modal-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="jari-paywall-modal">
        <h2 id="paywall-modal-title">
          {variant === "trial" ? "Aanschaf voor verder gebruik" : "Licentie vereist"}
        </h2>
        {variant === "trial" ? (
          <p>
            Je kunt alle onderdelen van deze tool 5 minuten uitproberen. Om alle
            functionaliteiten ongelimiteerd te gebruiken, kun je de {toolDisplayName}{" "}
            aanschaffen voor {priceLabel}.
          </p>
        ) : (
          <p>{licenseMessage(featureTitle)}</p>
        )}
        <div className="jari-paywall-modal__actions">
          <a href={purchaseUrl} className="jari-btn jari-btn--primary">
            Kopen
          </a>
          <button type="button" className="jari-btn" onClick={onClose}>
            Sluiten
          </button>
        </div>
      </div>
    </div>
  );
}
